import React, {useState} from "react";
import {Card, Menu} from "antd";
import Styles from "../platform-pages/admin/sys-site/index.module.css";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import D365Config from "./d365";
import ExternalConfig from "./external";
import Oa from "./oa";
import JdConfig from "./jd";

const siteMap: { [key: string]: any } = {
    d365: <D365Config/>,
    oa: <Oa/>,
    meinian: <ExternalConfig key={'美年'} system={'美年'}/>,
    yunyigou: <ExternalConfig key={'云医购'} system={'云医购'}/>,
    meinianNew: <ExternalConfig key={'新美年'} system={'新美年'}/>,
    jd: <JdConfig/>
}

function ApiConfig() {

    const [selectedKey, setSelectedKey] = useState('d365')

    const ContentElement = siteMap[selectedKey]

    return (
        <PageHeaderLayout>
            <Card>
                <div className={Styles.container}>
                    <Menu style={{width: 256}} mode="inline" selectedKeys={[selectedKey]}
                          onClick={({key}) => setSelectedKey(key.toString())} items={[
                        {label: 'D365', key: 'd365'},
                        {label: 'OA', key: 'oa'},
                        {label: '美年', key: 'meinian'},
                        {label: '云医购', key: 'yunyigou'},
                        {label: '京东快递', key: 'jd'},
                        {label: '新美年', key: 'meinianNew'},
                    ]}/>
                    <div className={Styles.pageContainer}>
                        {ContentElement}
                    </div>
                </div>
            </Card>
        </PageHeaderLayout>
    )
}

export default ApiConfig
